module.exports = __webpack_public_path__ + "static/media/ic_audio_off.20f35632.svg";